var map = {
	"./armenial.jpg": 8405,
	"./australial.jpg": 1912,
	"./belarusl.jpg": 9510,
	"./bosnial.jpg": 5280,
	"./canadal.jpg": 2050,
	"./georgial.jpg": 6162,
	"./germanyl.jpg": 5243,
	"./indial.jpg": 9109,
	"./irelandl.jpg": 3777,
	"./italyl.jpg": 8673,
	"./japanl.jpg": 2414,
	"./kazakhl.jpg": 3230,
	"./koreal.jpg": 432,
	"./kyrgl.jpg": 3507,
	"./philippinesl.jpg": 2449,
	"./russial.jpg": 2577,
	"./ukl.jpg": 360,
	"./usal.jpg": 5409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2984;